import React from 'react'
import PropTypes from 'prop-types'

import * as styles from './styles'

import renderImageErrorDef from './renderers/render-image-error'
import renderImageLoaderDef from './renderers/render-image-loader'

const SmartImageComponent = ({
  source,
  loading,
  rounded,
  crashed,
  renderImageLoader = renderImageLoaderDef,
  renderImageError = renderImageErrorDef,
  alt,
  onLoad,
  onError,
  style,
  className,
}) => (
  <>
    {loading && renderImageLoader(className)}
    {crashed && renderImageError(className)}
    {!crashed && (
      <img
        id={alt}
        src={source}
        alt={alt}
        onLoad={onLoad}
        onError={onError}
        style={style}
        css={[rounded && styles.rounded, loading && styles.loading]}
        className={className}
      />
    )}
  </>
)

SmartImageComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  crashed: PropTypes.bool.isRequired,
  rounded: PropTypes.bool,
  source: PropTypes.string.isRequired,
  alt: PropTypes.string,
  style: PropTypes.shape(),
  className: PropTypes.string,
  onLoad: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  renderImageLoader: PropTypes.func,
  renderImageError: PropTypes.func,
}

export default SmartImageComponent
